<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.point')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <b-tabs content-class="mt-3" justified>
              <b-tab title="Üye Puan Hareketleri" active>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group :label="$t('users.points.point_cup_transaction')">
                      <b-form-select
                          v-model="form.point_type"
                          :options="point_types"
                          class="form-control form-control-solid"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group label="Açıklama">
                      <b-form-input
                          type="text"
                          class="form-control form-control-solid"
                          placeholder="Açıklama"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('users.points.point_cup')">
                      <b-form-input
                          type="number"
                          value="1"
                          class="form-control form-control-solid"
                          :placeholder="$t('users.points.point_cup')"
                      ></b-form-input>
                    </b-form-group>
                    <b-button @click="ConfirmPointAction" size="sm">İşlemi Gerçekleştir</b-button>
                  </div>
                  <div class="col-md-4">
                    <div class="py-9">
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Reklam Puanları:</span>
                        <a class="text-muted text-hover-primary">0.00</a>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Profil Bilgileri Puanları:</span>
                        <span class="text-muted">0.00</span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Kampanya Puanları:</span>
                        <span class="text-muted">5.300.00</span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Puan Düzeltme:</span>
                        <span class="text-muted">100.00</span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Siteye Giriş:</span>
                        <span class="text-muted">1.340.00</span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Kupa Sayısı:</span>
                        <span class="text-muted">20</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 border-left">
                    <div class="py-9">
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Anket Puanları:</span>
                        <a class="text-muted text-hover-primary">52.710.00</a>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Arkadaş Puanları:</span>
                        <span class="text-muted">0.00</span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Ödenen Puanları:</span>
                        <span class="text-muted">0.00</span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Toplam Puanlar:</span>
                        <span class="text-muted">59.450.00</span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="font-weight-bold mr-2">Puanların TL Karşılığı:</span>
                        <span class="text-muted">59.45 TL</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="separator separator-dashed mb-6 mt-5"></div>
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group>
                      <b-form-input
                          size="sm"
                          type="date"
                          value="2020-12-01"
                          class="form-control form-control-solid"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group>
                      <b-form-input
                          size="sm"
                          type="date"
                          value="2020-12-31"
                          class="form-control form-control-solid"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-dropdown id="dropdown-1" text="Puan Türü" size="sm">
                      <b-dropdown-item>Giriş</b-dropdown-item>
                      <b-dropdown-item >Anket</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <div class="col-md-4">

                    <div class="fa-pull-right">
                      <b-button-group>
                        <b-button size="sm"><i class="fas fa-file-download mr-2"></i> Listeyi Getir</b-button>
                        <b-dropdown id="dropdown-1" text="İşlemler" size="sm">
                          <b-dropdown-item><i class="far fa-file-excel mr-2"></i> Excel'e Aktar</b-dropdown-item>
                          <b-dropdown-item disabled>Seçilenleri İptal Et</b-dropdown-item>
                        </b-dropdown>
                      </b-button-group>



                    </div>
                  </div>
                </div>
                <div class="separator separator-dashed mb-6"></div>
                <div class="row">
                  <div class="col-md-12">
                    <data-table
                        :items="table.items"
                        :fields="report.fields"
                        :paginate="report.paginate"
                        :responsive="table.responsive"
                        page.sync="3"
                        perPage.sync="10"
                    ></data-table>
                  </div>
                </div>

              </b-tab>
              <b-tab title="Üye Puan - Para Talepleri">
                <div class="row mb-5 mt-5">
                  <div class="col-md-12">
                    <div class="fa-pull-right">
                      <b-button size="sm"><i class="fas fa-file-download mr-2"></i> Listeyi Getir</b-button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <data-table
                        :items="table.items_2"
                        :fields="report.fields2"
                        :paginate="report.paginate"
                        :responsive="table.responsive"
                        page.sync="3"
                        perPage.sync="10"
                    ></data-table>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import Swal from "sweetalert2";

export default {
  name: "Points",
  components: {DataTable},
  data() {
    return {
      form : {
        point_type : null,
      },
      table : {
        items: [
          { 'id': '90387755', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '500.00','InsertedDate': '17.07.2020 11:18'},
          { 'id': '90387754', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '200.00','InsertedDate': '12.07.2020 11:18'},
          { 'id': '17864812', 'description': "Giriş Puanı", 'admin_desc': "Giriş Puanı", 'Point' : '5.00','InsertedDate': '12.07.2020 11:18'},
          { 'id': '90387753', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '100.00','InsertedDate': '11.07.2020 11:18'},
          { 'id': '90387752', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '300.00','InsertedDate': '10.07.2020 11:18'},
          { 'id': '17864812', 'description': "Giriş Puanı", 'admin_desc': "Giriş Puanı", 'Point' : '5.00','InsertedDate': '12.07.2020 11:18'},
          { 'id': '90387751', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '250.00','InsertedDate': '18.07.2020 11:18'},
          { 'id': '90387750', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '400.00','InsertedDate': '13.07.2020 11:18'},
          { 'id': '17864812', 'description': "Giriş Puanı", 'admin_desc': "Giriş Puanı", 'Point' : '5.00','InsertedDate': '12.07.2020 11:18'},
          { 'id': '90387749', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '350.00','InsertedDate': '14.07.2020 11:18'},
          { 'id': '90387548', 'description': "Anket", 'admin_desc': "Anket", 'Point' : '700.00','InsertedDate': '15.07.2020 11:18'},
          { 'id': '17864812', 'description': "Giriş Puanı", 'admin_desc': "Giriş Puanı", 'Point' : '5.00','InsertedDate': '12.07.2020 11:18'},
        ],
        items_2 : [
          { 'id': '90387755', 'status': "", 'changer': "", 'request_date' : '','updated_at': '17.07.2020', 'campaign' : '', 'promotion_code' : '', 'point' : '', 'iban' : '' },
          { 'id': '90387755', 'status': "", 'changer': "", 'request_date' : '','updated_at': '17.07.2020', 'campaign' : '', 'promotion_code' : '', 'point' : '', 'iban' : '' },
          { 'id': '90387755', 'status': "", 'changer': "", 'request_date' : '','updated_at': '17.07.2020', 'campaign' : '', 'promotion_code' : '', 'point' : '', 'iban' : '' },
          { 'id': '90387755', 'status': "", 'changer': "", 'request_date' : '','updated_at': '17.07.2020', 'campaign' : '', 'promotion_code' : '', 'point' : '', 'iban' : '' },
        ]
      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 10,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'checkbox', label: 'Seç', sortable: false},
          {key: 'id', label: 'ID', sortable: false},
          {key: 'description', label: 'Açıklama', sortable: true},
          {key: 'admin_desc', label: 'Yönetici Açıklama', sortable: true},
          {key: 'Point', label: 'Puan', sortable: true},
          {key: 'InsertedDate', label: 'Tarih', sortable: true},
        ],
        fields2: [
          {key: 'id', label: 'ID', sortable: false},
          {key: 'status', label: 'Durum', sortable: true},
          {key: 'changer', label: 'Değiştiren', sortable: true},
          {key: 'request_date', label: 'Talep Tarihi', sortable: true},
          {key: 'updated_at', label: 'Güncelleme Tarihi', sortable: true},
          {key: 'campaign', label: 'Kampanya', sortable: true},
          {key: 'promotion_code', label: 'Promosyon Kodu', sortable: true},
          {key: 'point', label: 'Puan', sortable: true},
          {key: 'iban', label: 'IBAN', sortable: true},

        ],
      },
      point_types: [
          { text: this.$t('general.select'), value: null },
        'Yönetici Puan Ekleme',
        'Yönetici Puan Düşme',
        'Yönetici Kupa Ekleme',
        'Yönetici Kupa Düşme',
      ],

    }
  },
  methods : {
    ConfirmPointAction(){
      Swal.fire({
        title: "Dikkat!",
        text: "Bu işlemi onaylıyor musunuz?",
        icon: "question",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Evet",
        showCancelButton: true,
        cancelButtonClass: "btn btn-warning",
        cancelButtonText: "Hayır"
      });
    }
  }
};
</script>
